import { Card, CardTitle, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { responsiveCarousel } from "../responsive";
import { boostConversionsCover, buyBoxCover, primeBenefitsCover, tradeInCover, usingAiCover, warehouseCover } from "../covers";

export default function TipsCarousel () {
    return (
        <Container>
        <Carousel 
            additionalTransfrom={0}
            arrows
            centerMode={false}
            className=""
            containerClass="container-with-dots"
            dotListClass=""
            draggable
            focusOnSelect={false}
            itemClass=""
            keyBoardControl
            minimumTouchDrag={80}
            pauseOnHover
            renderArrowsWhenDisabled={false}
            renderButtonGroupOutside={false}
            autoPlay={false}
            responsive={responsiveCarousel}
            rewind={true}
            rewindWithAnimation={false}
            showDots={false}
            sliderClass=""
            slidesToSlide={1}
            swipeable
            > 
                <Card className="homeCard">
                        <Link to="/smartShoppingAi" className="cardLink">
                            <div>
                                <img className="homeCardImage" src={ usingAiCover.src } alt={ usingAiCover.alt }/>
                                <Container className="homeCardBody">
                                    <CardTitle>Smart Shopping: Using AI to Stay Ahead of Trendy Products</CardTitle>
                                    <span className="homePostPublish">Published on October 13th, 2024</span>
                                </Container>
                            </div>
                        </Link>
                </Card>

                <Card className="homeCard">
                        <Link to="/tradeIn" className="cardLink">
                            <div>
                                <img className="homeCardImage" src={ tradeInCover.src } alt={ tradeInCover.alt }/>
                                <Container className="homeCardBody">
                                    <CardTitle>Saving with Amazon's Trade-In Program</CardTitle>
                                    <span className="homePostPublish">Published on October 10th, 2024</span>
                                </Container>
                            </div>
                        </Link>
                </Card>

                <Card className="homeCard">
                        <Link to="/amazonWarehouse" className="cardLink">
                            <div>
                                <img className="homeCardImage" src={ warehouseCover.src } alt={ warehouseCover.alt }/>
                                <Container className="homeCardBody">
                                    <CardTitle>How to Use Amazon Warehouse to Find Better Deals</CardTitle>
                                    <span className="homePostPublish">Published on October 9th, 2024</span>
                                </Container>
                            </div>
                        </Link>
                </Card>

                <Card className="homeCard">
                        <Link to="/primeBenefits" className="cardLink">
                            <div>
                                <img className="homeCardImage" src={ primeBenefitsCover.src } alt={ primeBenefitsCover.alt }/>
                                <Container className="homeCardBody">
                                    <CardTitle>The Top Benefits of Amazon Prime for Shoppers</CardTitle>
                                    <span className="homePostPublish">Published on October 8th, 2024</span>
                                </Container>
                            </div>
                        </Link>
                </Card>
                <Card className="homeCard">
                        <Link to="/buyBox" className="cardLink">
                            <div>
                                <img className="homeCardImage" src={ buyBoxCover.src } alt={ buyBoxCover.alt }/>
                                <Container className="homeCardBody">
                                    <CardTitle>Unlocking the Power of Amazon Listings: Understanding the Buy Box and Finding Better Deals</CardTitle>
                                    <span className="homePostPublish">Published on October 7th, 2024</span>
                                </Container>
                            </div>
                        </Link>
                </Card>

                <Card className="homeCard">
                    <Link to="/boostConversions" className="cardLink">
                        <div>
                            <img className="homeCardImage" src={ boostConversionsCover.src } alt={ boostConversionsCover.alt }/>
                            <Container className="homeCardBody">
                                <CardTitle>Boost Conversions with Product Recommendation Strategies</CardTitle>
                                <span className="homePostPublish">Published on October 5th, 2024</span>
                            </Container>
                        </div>
                    </Link>
                </Card>
        </Carousel>
    </Container>
    )
}